module.exports = __webpack_public_path__ + "img/default.d2032b06.svg";